module.exports = __webpack_public_path__ + "img/icons-03.71496d7a.svg";